import { NavLink, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "../styles/About.css";

const About = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <section class="aboutHeroWrapper">
        <div class="leftAbout">
          <h1>
            About <span>Enugu</span> USA
          </h1>
          <div class="aboutDetails">
            <p>
              Enugu USA, a beacon of unity and progress for the Enugu State
              diaspora, traces its roots back to a visionary gathering in
              Maryland during the 1998 FIFA World Cup. From that pivotal moment,
              our organization has been dedicated to partnering with our home
              government and fostering development in Enugu State. Despite
              initial setbacks, our resolve remained unshaken as we embarked on
              our journey, spreading our message of collaboration and
              empowerment across the United States.
            </p>

            <p>
              Through conventions held in various cities and landmark
              initiatives, such as bringing internet connectivity to Enugu and
              advocating for community policing, Enugu USA has demonstrated
              unwavering commitment to its mission. From Los Angeles to New
              Jersey, Atlanta to Houston, our conventions have been a testament
              to our unity and determination. Along the way, we've celebrated
              milestones, weathered challenges, and embraced the spirit of
              sisterhood and brotherhood that defines our community.
            </p>
            <p>
              As we mark our Silver Jubilee, we honor the dedication and
              perseverance of past leaders and members who have paved the way
              for our success. Looking ahead, we are inspired by the leadership
              of the new generation of Enugu Americans being prepared to carry
              our legacy forward. With gratitude for our history and excitement
              for the future, we stand united, ready to continue making a
              meaningful impact for generations to come.
            </p>
            <p>
              If you want to delve deeper into the rich history of Enugu USA and
              learn more about our journey over the past 25 years, we invite you
              to explore our comprehensive historical document titled "ENUGU-USA
              @ 25: A Brief History." This document provides an in-depth
              overview of our organization's founding, key milestones,
              initiatives, and the dedicated individuals who have shaped our
              story. Click [here](insert link) to access the document and
              discover the vibrant tapestry of our community's history.
            </p>

            <h3>Donations</h3>
            <p>
              Your generosity fuels our mission to make a positive impact in
              Enugu State and beyond. Every donation contributes directly to
              vital community projects, healthcare initiatives, educational
              programs, and empowerment efforts, ensuring a brighter future for
              all. Together, we can build stronger communities and transform
              lives. Thank you for your support!
            </p>
            <button onClick={() => navigate("/donations")}>Donate Now</button>
          </div>
        </div>
        <div class="rightAbout">
          <img
            src={require("../assets/images/convention/WhatsApp Image 2024-02-14 at 10.45.24_199a46ae_2.jpg")}
            alt=""
          />

          <div class="imageInfo">
            <h3>Current and Past Presidents of Enugu USA</h3>
          </div>
        </div>
      </section>

      {/* <!-- MISSION AND VISION STATEMENT --> */}

      <section class="missionVisionWrapper">
        <div class="missionWrapper">
          <div class="mission">
            <h3>Our Mission</h3>
            <p>
              At Enugu USA, our mission is to foster unity, empowerment, and
              community development for the people of Enugu State, Nigeria, and
              its diaspora. Founded on the principles of service, collaboration,
              and compassion, we strive to make a lasting impact through
              initiatives that address education, healthcare, economic
              empowerment, and social welfare. With a legacy of 25 years of
              dedication and resilience, we continue to innovate and lead,
              guided by our vision to build a brighter future for all, one heart
              and one community at a time.
            </p>
          </div>
          <img
            src={require("../assets/images/2022MedicalMision/PHOTO-2023-12-02-21-50-30_3.jpg")}
            alt=""
          />
        </div>
        <div class="missionWrapper vissionWrapper">
          <div class="mission vision">
            <h3>Our Vision</h3>
            <p>
              Enugu USA envisions a thriving and united community where every
              individual, regardless of background or circumstance, has the
              opportunity to reach their full potential. Guided by our shared
              values of integrity, compassion, and solidarity, we aspire to be a
              catalyst for positive change, driving sustainable development,
              fostering cultural pride, and building a legacy of hope and
              opportunity for generations to come in Enugu State and beyond.
            </p>
          </div>
          <img src={require("../assets/images/enugulogo.png")} alt="" />
        </div>
      </section>

      {/* <!-- VALUES WRAPPER --> */}

      <section class="valuesWrapper">
        <h2>Our Corporate values</h2>
        <div class="valuesCardWrapper">
          <div class="valuesCard">
            <span class="material-symbols-outlined"> globe_uk </span>
            <h3>Unity</h3>
            <p>
              At Enugu USA, we believe in the power of unity to achieve
              meaningful and lasting change. We strive to foster a sense of
              belonging and collaboration among our members, recognizing that
              together, we can overcome challenges, celebrate successes, and
              make a greater impact on our community.
            </p>
          </div>
          <div class="valuesCard">
            <span class="material-symbols-outlined"> handshake </span>
            <h3>Integrity</h3>
            <p>
              Integrity is at the core of everything we do. We uphold the
              highest ethical standards in our actions and decisions, ensuring
              transparency, honesty, and accountability in all our endeavors. We
              are committed to earning and maintaining the trust and respect of
              our members, partners, and stakeholders.
            </p>
          </div>
          <div class="valuesCard">
            <span class="material-symbols-outlined"> volunteer_activism </span>
            <h3>Compassion</h3>
            <p>
              Compassion lies at the heart of our organization's mission. We
              approach our work with empathy, understanding, and a genuine
              desire to make a positive difference in the lives of others. We
              strive to be a source of support, comfort, and empowerment for
              those in need, guided by a deep sense of empathy and humanity.
            </p>
          </div>
          <div class="valuesCard">
            <span class="material-symbols-outlined"> concierge </span>
            <h3>Service</h3>
            <p>
              Service is a fundamental value that drives our organization's
              mission. We are dedicated to serving the needs of our community,
              prioritizing the well-being and prosperity of our communities,
              Enugu State and its residents. Through our actions and
              initiatives, we seek to uplift and empower individuals, families,
              and communities, leaving a lasting legacy of impact and positive
              change.
            </p>
          </div>
          <div class="valuesCard">
            <span class="material-symbols-outlined"> psychology </span>
            <h3>Innovation</h3>
            <p>
              Innovation is essential to our organization's success and
              sustainability. We embrace creativity, adaptability, and
              forward-thinking in our approach to addressing complex challenges
              and opportunities. We strive to continuously innovate and evolve,
              exploring new ideas, technologies, and strategies to enhance our
              impact and effectiveness in serving our community.
            </p>
          </div>
        </div>
      </section>

      {/* <!-- OUR EXECUTIVES --> */}
      <section class="executivesWrapper">
        <h2>Our Executives</h2>
        <p>
          Our Executive Committee comprises visionary leaders who embody the
          values of integrity, compassion, and unity. With a diverse range of
          expertise and a shared mission to empower and uplift Enugu State and
          its diaspora, our executives work tirelessly to steer our organization
          towards a brighter future. Get to know the faces behind our mission,
          and join us in our journey to make a meaningful difference in the
          lives of others.
        </p>
        <NavLink to={"/currentexecutives"}>Meet our Executives</NavLink>
      </section>
      <Footer />
    </>
  );
};

export default About;
